type MiddlewareMeta = boolean | 'forbidden'

declare module '#app' {
  interface PageMeta {
    auth?: MiddlewareMeta
  }
}

async function ensureSessionLoaded() {
  const { me, loading, fetchMe } = useAuth()

  if (me.value === undefined && !loading.value) {
    await fetchMe()
  }
}

export default defineNuxtRouteMiddleware(async (to) => {
  const pageAuthRule = to.meta.auth

  if (pageAuthRule === false) {
    return
  }

  if (pageAuthRule === 'forbidden') {
    await ensureSessionLoaded()

    if (useAuth().status.value === 'authenticated') {
      return navigateTo('/', { external: true })
    }

    return
  }

  await ensureSessionLoaded()

  const { status } = useAuth()

  if (
    status.value === 'unauthenticated' &&
    to.name !== 'login'
  ) {
    return navigateTo({
      name: useRuntimeConfig().public.auth
        .loginPageRouteName,
    })
  }
})
